var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commentPageContainer"},[(_vm.isLoading)?_c('div',[_vm._v("Loading card images...")]):_c('div',[_c('div',{staticClass:"cardImageHeaderContainer"},[_c('v-data-table',{staticClass:"transparent",attrs:{"headers":_vm.cardHeaders,"items":_vm.multiverseCards,"footer-props":{
          'items-per-page-options': [],
          'items-per-page-text': null,
          'disable-items-per-page': true
          },"options":_vm.printingSelectOptions},scopedSlots:_vm._u([{key:"item",fn:function(ref){
          var item = ref.item;
return [_c('img',{staticClass:"cardimgselect",attrs:{"src":_vm.generateImageLink(item)},on:{"click":function($event){return _vm.filterMultiverseIds(item)}}})]}}])})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }